export const isEmpty = (prop: unknown) => {
  if (prop === undefined) return true;
  else if (typeof prop === "string" && (prop === "" || (!isNaN(Number(prop)) && Number(prop) === 0))) return true;
  else if (prop === 0) return true;
  else if (Array.isArray(prop) && prop.length === 0) return true;
  return false;
};
export default function arePlainObjectsEqual<T>(
  object1: T,
  object2: T,
  keys: (keyof T)[],
  accountForEmpty = false,
) {
  return keys.reduce((previousValue, currentKey) => {
    return (
      previousValue &&
      (object1[currentKey] === object2[currentKey] ||
        (accountForEmpty &&
          isEmpty(object1[currentKey]) &&
          isEmpty(object2[currentKey])))
    );
  }, true);
}
